<div class="loading-grid" aria-busy="true" aria-live="polite">
    <span class="sr-only">Loading events…</span>
    <div class="ghost-card" *ngFor="let i of placeholders" aria-hidden="true">
        <div class="ghost-image"></div>
        <div class="ghost-body">
            <div class="ghost-line w-40"></div>
            <div class="ghost-line w-85"></div>
            <div class="ghost-line w-70"></div>
            <div class="ghost-line w-55"></div>
        </div>
    </div>
</div>
